<template>
  <div class="parent-container">
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
        <el-button size="small" type="success" @click="handleEdit()">多次邮寄申请</el-button>
        <span style="color:red;font-size: 15px;font-weight: bold;margin-left: 10px">注：需要多次邮寄的合同在此申请</span>
      </div>
      <export-components :apiFunction="exportMail" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <table-col :cols="column" :table-col="column" :columnType="'mailTableCol1' + activeTab" @submit="getCheckedBox"></table-col>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(mailInfo,mailIndex) in data" :key="mailIndex" :label="mailInfo.label"
        :name="mailInfo.name"></el-tab-pane>
    </el-tabs>
    <w-table :columns="checkedCol" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true"
      :key="activeTab">
      <div slot="operation" slot-scope="{record}">
        <el-dropdown @command="(command) => download( record,command.type,command.name)" size="small"
          style="margin-left: 10px;margin-right: 10px">
          <el-button type="warning" size="mini">下载附件<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="record?.mailAttachment?.['MAIL_ANNEX'] && Object.keys(record.mailAttachment['MAIL_ANNEX']).length>0"
              :command="{type:'MAIL_ANNEX',name:Object.keys(record.mailAttachment['MAIL_ANNEX']).length>1?'completeAttachments':''}">单独邮寄附件</el-dropdown-item>
            <el-dropdown-item
              v-if="record?.mailAttachment?.['CONTRACT_SCANNING_ANNEX'] && Object.keys(record.mailAttachment['CONTRACT_SCANNING_ANNEX']).length>0"
              :command="{type:'CONTRACT_SCANNING_ANNEX',name:''}">合同扫描文件</el-dropdown-item>
            <el-dropdown-item
              v-if="record?.mailAttachment?.['REPORT_ANNEX'] && Object.keys(record.mailAttachment['REPORT_ANNEX']).length>0"
              :command="{type:'REPORT_ANNEX',name:Object.keys(record.mailAttachment['REPORT_ANNEX']).length>1?'completeAttachments':''}">结题报告</el-dropdown-item>
            <el-dropdown-item
              v-if="record?.mailAttachment?.['REPORT_SCANNING_ANNEX'] && Object.keys(record.mailAttachment['REPORT_SCANNING_ANNEX']).length>0"
              :command="{type:'REPORT_SCANNING_ANNEX',name:''}">结题报告扫描文件</el-dropdown-item>
            <el-dropdown-item
              v-if="record?.mailAttachment?.['REIMBURSEMENT_ANNEX'] && Object.keys(record.mailAttachment['REIMBURSEMENT_ANNEX']).length>0"
              :command="{type:'REIMBURSEMENT_ANNEX',name:Object.keys(record.mailAttachment['REIMBURSEMENT_ANNEX']).length>1?'completeAttachments':''}">报账资料</el-dropdown-item>
            <el-dropdown-item
              v-if="record?.mailAttachment?.['REIMBURSEMENT_SCANNING_ANNEX'] && Object.keys(record.mailAttachment['REIMBURSEMENT_SCANNING_ANNEX']).length>0"
              :command="{type:'REIMBURSEMENT_SCANNING_ANNEX',name:''}">报账资料扫描文件</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button size="mini" type="success" v-if="record.mailFlag === 'CANCELED'"
          @click="handleEdit(record)">重新提交</el-button>
      </div>
      <div slot="recipient" slot-scope="{record}">
        <span v-if="record.recipientName">{{record.recipientName + ',' + record.recipientPhone + ',' +
          record.recipientAddress}}</span>
      </div>
      <div slot="mailFlag" slot-scope="{text,record}">
        <el-tag v-if="text === 'NOT_APPLYING'" type="primary">未申请</el-tag>
        <el-tag v-else-if="text === 'SUBMITTED' && record.mailAuditFlag" type="warning"
          style="background-color: #FFFFFF">待邮寄</el-tag>
        <el-tag v-else-if="text === 'SUBMITTED' && !record.mailAuditFlag" type="warning">待审核</el-tag>
        <el-tag v-else-if="text === 'MAILED'" type="success">已邮寄</el-tag>
        <el-tag v-else-if="text === 'NOT_MAILED'" type="danger" style="background-color:#ffffff;">不邮寄</el-tag>
        <span v-else-if="text === 'CANCELED'" style="display: flex;align-items: center">
          <el-tag type="danger">
            <span>已取消</span>
          </el-tag>
          <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
            :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
        <el-tag v-else type="info">未知状态</el-tag>
      </div>
      <div slot="mailNumbers" slot-scope="{text,record,index}">
        <ex-fold-form :scope="{time:text, index,type:'mail'}"></ex-fold-form>
      </div>
      <div slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </div>
      <div slot="contactName" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </div>
      <div slot="mailingContent" slot-scope="{text,record,index}" v-if="text">
        <el-button size="mini" type="success" @click="showContent(record)">查看邮寄内容</el-button>
      </div>
      <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待邮寄'>待邮寄</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已邮寄'>已邮寄</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已取消'>已取消</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <add-edit-mail v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :selectType="selectType"
      :select-detail="selectDetail" @submit="closeAddEditDialog">
    </add-edit-mail>
    <show-mailing-content v-if="showMailContent" :select-detail="mailingContentInfo" :show-dialog="showMailContent"
      @submit="closeShowMailInfo"></show-mailing-content>
  </div>
</template>

<script>

import {getDataInLocalStorage} from "@/utils/localStorage";
import {attachmentMail, exportMail, getMailPage} from "@/api/dilivery/mail";
import {mail} from "@/utils/data/tableCol/mail/mail";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import ExFoldForm from "@/components/ExFoldForm.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import TableCol from "@/components/customerTable/TableCol.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import AddEditMail from "@/components/mail/AddEditMail.vue";
import ShowMailingContent from "@/components/mail/ShowMailingContent.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "Mail",
  components: {
    ExportComponents,
    ShowMailingContent,
    AddEditMail,
    PictureLoading,
    TableCol,
    ExFoldForm, ContractDetails, ExFoldCell, ExFoldTableCell, ExFoldTable, TableHeadNote
  },
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '待审核', name: 'AUDIT', showBadge: true },
        { label: '待邮寄', name: 'SUBMITTED', showBadge: false },
        { label: '已邮寄', name: 'MAILED', showBadge: false },
        { label: '已取消', name: 'CANCELED', showBadge: false },
      ],
      sendData: {
        all: {},
        AUDIT: { "mailAuditFlag": false },
        SUBMITTED: { "query#mailFlag.EQ": "SUBMITTED", "mailAuditFlag": true },
        MAILED: { "query#mailFlag.EQ": "MAILED" },
        CANCELED: { "query#mailFlag.EQ": "CANCELED" },
      },
      pageTotal: { all: 0, AUDIT: 0, SUBMITTED: 0, MAILED: 0, CANCELED: 0 },
      loading: true,
      showMailContent: false,
      mailingContentInfo: {},
      userData: {},
      role: '',
      showDetails: '',
      showAddEditDialog: false,
      selectDetail: '',
      selectType: {},
      activeTab: 'all',
      checkedCol: [],
      option: [
        { label: '申请时间', value: 'applicantDate' },
        { label: '创建时间', value: 'createTime' },
      ],
    }
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  computed: {
    column() {
      let cols = mail([] || {});
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    exportMail,
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    async download(row, type, name) {
      try {
        const fileName = (name ? '/' : '') + name
        let url = `${baseURL}/mail-info/attachment/${row.id}/${type}${fileName}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
        'order': 'materialNumber.descend'
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10, 'order': 'materialNumber.descend' }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getMailPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      })
    },
    showContent(row) {
      this.showMailContent = true
      this.mailingContentInfo = row
    },
    closeShowMailInfo() {
      this.$nextTick(() => { this.showMailContent = false })
      this.mailingContentInfo = {}
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'mailFlag') {
          if (['待审核', '待邮寄'].includes(value)) {
            value = 'SUBMITTED'
          } else if (value === '已邮寄') {
            value = 'MAILED'
          } else {
            value = 'CANCELED'
          }
        }
        if (['saleName', 'contractNumber', 'chargeName', 'contactName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          if (item.key === 'mailFlag' && ['待审核', '待邮寄'].includes(item.value)) {
            sendData['mailAuditFlag'] = item.value !== '待审核';
          }
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = { type: 'edit' }
      } else {
        this.selectType = { type: 'add' }
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => { this.showAddEditDialog = false })
    },
    getCheckedBox(col, cols) {
      this.checkedCol = col.filter(item => cols.includes(item.title))
    },
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.parent-container {
  position: relative;
  overflow: hidden;
}

.add-edit-mail {
  position: absolute;
}
</style>
